import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide toggle. Renders a full-width input with a
 * right-aligned eye icon button.
 */
export default function PasswordField({
  value,
  onChange,
  placeholder = "Password",
  testId = "password-input",
  minLength = 8,
  autoComplete = "current-password",
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        type={visible ? "text" : "password"}
        className="input-native pr-11"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        minLength={minLength}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid={`${testId}-toggle`}
        aria-label={visible ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-md text-neutral-500 hover:text-black hover:bg-neutral-100 flex items-center justify-center"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
